import Chance from "chance";
import { DateTime } from "luxon";

const chance = new Chance();

chance.mixin({
  drEvent: () => {
    const eventDateStart = DateTime.fromMillis(Date.now()).minus({
      hours: chance.integer({ min: 0, max: 10000 })
    });

    const resourceActivations = chance.pickset(resourcesAndContributors(), 3);
    const demandResponse = resourceActivations.reduce(
      (a, v) => a.concat(v.contributors),
      []
    );

    return {
      id: chance.fbid(),
      eventDay: eventDateStart.toFormat("yyyy/000"),
      eventStart: eventDateStart.toMillis(),
      eventEnd: eventDateStart.plus({ hours: 4 }).toMillis(),
      resourceActivations: resourceActivations,
      demandResponse: demandResponse
    };
  }
});

export default async ({ offset, limit = 10 }) => {
  return new Promise(resolve => {
    setTimeout(() => {
      let results = chance.n(chance.drEvent, limit);
      resolve({
        data: results,
        meta: {
          count: results.length,
          offset: offset,
          limit: limit
        }
      });
    }, 800);
  });
};

const resourcesAndContributors = () => [
  {
    resourceId: "resource1",
    description: "1 MW Toronto Resource",
    loadReduction: 1,
    loadReductionUnits: "MW",
    contributors: [
      {
        contributorId: "contributor1.1",
        capacityObligation: 1,
        capacityObligationUnits: "MW",
        name: "Alte-Rego",
        description: "Alte-Rego (1 MW) Contributor"
      }
    ]
  },
  {
    resourceId: "resource2",
    description: "2 MW West Resource",
    loadReduction: 2,
    loadReductionUnits: "MW",
    contributors: [
      {
        contributorId: "contributor2.1",
        capacityObligation: 0.5,
        capacityObligationUnits: "MW",
        name: "Pureflavor",
        description: "Pureflavor (0.5 MW) Contributor"
      },
      {
        contributorId: "contributor2.2",
        capacityObligation: 1,
        capacityObligationUnits: "MW",
        name: "Mastronadi",
        description: "Mastronadi (1 MW) Contributor"
      },
      {
        contributorId: "contributor2.4",
        capacityObligation: 0.2,
        capacityObligationUnits: "MW",
        name: "Klasseen Greenhouse",
        description: "Klasseen Greenhouse (0.2 MW) Contributor"
      },
      {
        contributorId: "contributor2.3",
        capacityObligation: 0.3,
        capacityObligationUnits: "MW",
        name: "Pure Hothouse",
        description: "Pure Hothouse (0.3 MW) Contributor"
      }
    ]
  },
  {
    resourceId: "resource3",
    description: "2.2 MW Southwest Resource",
    loadReduction: 2.2,
    loadReductionUnits: "MW",
    contributors: [
      {
        contributorId: "contributor3.1",
        capacityObligation: 2.2,
        capacityObligationUnits: "MW",
        name: "Monaghan Mushrooms",
        description: "Monaghan Mushrooms (2.2 MW) Contributor"
      }
    ]
  },
  {
    resourceId: "resource4",
    description: "1 MW East Resource",
    loadReduction: 1,
    loadReductionUnits: "MW",
    contributors: [
      {
        contributorId: "contributor3.1",
        capacityObligation: 1,
        capacityObligationUnits: "MW",
        name: "Ben Hokum",
        description: "Ben Hokum (1 MW) Contributor"
      }
    ]
  }
];
